<template>
    <!-- The Modal -->
    <b-modal
            id="copy-favourite-list-model"
            :title="'Copy Favourites'"
            v-model="modalOpen"
            no-fade
            size="lg"
            @change="onModalChange"
            @hide="onModalChange"
            @show="onModalChange">
        <template v-slot:modal-footer>
            <b-btn @click="modalOpen = false">Cancel</b-btn>
            <b-btn :disabled="!canCopy" @click="copyFavList">Copy Favourites</b-btn>
        </template>
        <div class="pb-3">
            This can copy from selected user's favourites or their favourite lists to your favourites or one of your favourite list.
        </div>
        <div class="selection-container">
            <b-form-group label-cols="3" label-size="sm" label="From Favourites or List">
                <b-form-select
                    ref="from_list"
                    v-model="fromListId"
                >
                    <option value="-1">All Favourites</option>
                    <option v-for="item of fromFavList" :value="item.id">
                        {{ item.name }}
                    </option>
                </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label-size="sm" label="To Favourites or List">
                <b-form-select
                    ref="from_list"
                    v-model="toListId"
                >
                    <option value="">-</option>
                    <option value="-1">My Favourites</option>
                    <option v-for="item of toFavList" :value="item.id">
                        {{ item.name }}
                    </option>
                </b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>
<script>
    export default {
      props: [
        'selectedAuctionDate',
        'selectedListId',
        'userFilter',
        'value',
      ],
        data() {
            return {
                modalOpen: this.value,
                fromFavList: [],
                toFavList: [],
                fromListId: null,
                fromUserId: this.userFilter,
                toListId: null,
                loading: false,
            }
        },
        watch: {
            value(){
                this.modalOpen = !!this.value;
            },
            selectedListId(){
                this.setFromListId()
            },
            userFilter(){
              this.fromUserId = this.userFilter;
              // update fromFavList
              this.getUserFavLists(this.fromUserId)
            }
        },
        computed: {
            canCopy(){
                return this.fromListId && this.toListId && !this.loading
            }
        },
        methods: {
            onModalChange(){
                this.$emit('input', this.modalOpen);
            },
            async getUserFavLists(user_id){
                let args = {
                    auction_date: this.selectedAuctionDate
                };
                if (user_id) {
                    // setup user id if exist is not set default is current user
                    args.user_id = user_id;
                }
                await this.$store.dispatch('favourites/getFavouriteListByUser', args).then(response => {
                    // check if data exist
                    if (response && response.favourites && response.favourites.data) {
                        // when user id is set then set fromFavList else set toFavList(default to logged in user)
                        if (user_id) {
                            this.fromFavList = response.favourites.data;
                        } else {
                            this.toFavList = response.favourites.data;
                        }
                    }
                }).catch(e => console.warn('CopyFavListModal/getUserFavLists catch', e));
            },
            async copyFavList(){
              let args = {
                    from_list_id: this.fromListId,
                    to_list_id: this.toListId,
                    from_user_id: this.userFilter,
                    auction_date: this.selectedAuctionDate,
                };
                this.loading = true;
                await this.$store.dispatch('favourites/copyFavouriteList', args).then(response => {
                    // check if data message exist
                    if (response && response.message) {
                        const type = response.success ? 'success' : 'error';
                        const title = response.success ? 'Success' : 'Error';
                        this.$notify({
                            title: title,
                            message: response.message,
                            type: type
                        });
                        if (response.success) {
                            // close modal
                            this.modalOpen = false;
                            // reset fromListId and toListId
                            this.fromListId = -1;
                            this.toListId = null;
                        }
                    }
                }).catch(e => console.warn('CopyFavListModal/copyFavList catch', e));
                this.loading = false
            },
            setFromListId(){
                if (this.selectedListId) {
                    this.fromListId = this.selectedListId;
                } else {
                    this.fromListId = -1;
                }
            }
        },
        mounted() {
            this.setFromListId()
            // set fromUserId
            if (this.$route.query && this.$route.query.user_id) {
                this.fromUserId = parseInt(this.$route.query.user_id)
                // set fromFavList
                this.getUserFavLists(this.fromUserId)
            }
            // set toFavList
            this.getUserFavLists()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/CopyFavListModal.vue